import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=4cdf2c57&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cdf2c57')) {
      api.createRecord('4cdf2c57', component.options)
    } else {
      api.reload('4cdf2c57', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=4cdf2c57&", function () {
      api.rerender('4cdf2c57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeliveryNote/MaintainDeliveryNote2/Edit.vue"
export default component.exports